module.exports = __webpack_public_path__ + "static/media/sjukmat_logo@2x.5e865cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjukmat_logo@2x.png
// module id = 122
// module chunks = 0